// The values of the payment tables' enum columns: a payment started at checkout, a refund as the card
// processor knows it, and a dispute a customer's bank opened. Stripe's own codes (a dispute's reason and
// status, a refund's failure) are stored as Stripe sends them and are translated here like any enum.
// enumLabels.ts spreads this in.
export const PURCHASE_TYPES: Record<string, string> = {
  JourneyReservation: "Rezervim udhëtimi",
  ApplicationForReservationAddition: "Shtesë e rezervimit",
  EsimReservation: "Rezervim eSIM"
};

// The booking's refund list and dispute banner read these too, so each state has one wording.
export const PROCESSOR_REFUND_STATUS: Record<string, string> = {
  Pending: "Në proces te banka",
  Succeeded: "Paguar",
  Failed: "Dështoi",
  Canceled: "Anuluar te banka"
};

export const DISPUTE_PROCESSOR_STATUS: Record<string, string> = {
  needs_response: "Pret përgjigjen tonë",
  warning_needs_response: "Pret përgjigjen tonë",
  under_review: "Në shqyrtim te banka",
  warning_under_review: "Në shqyrtim te banka",
  won: "U fitua",
  lost: "U humb",
  warning_closed: "U mbyll",
  prevented: "U parandalua",
  open: "I hapur"
};

export const PAYMENT_ENUM_LABELS: Record<string, Record<string | number, string>> = {
  "PaymentAttempt.EntityName": PURCHASE_TYPES,
  "PaymentAttempt.Rail": {
    StripeCard: "Kartelë (Stripe)",
    StripeExpress: "Apple Pay / Google Pay (Stripe)",
    Nlb: "Kartelë (NLB)",
    CreditsOnly: "Vetëm Gjirafa Money"
  },
  "PaymentAttempt.CaptureMode": {
    Immediate: "Menjëherë",
    Manual: "Pasi të konfirmohet blerja"
  },
  "PaymentAttempt.Status": {
    Open: "E hapur",
    Authorized: "E autorizuar",
    Completing: "Duke u përfunduar",
    Completed: "E përfunduar",
    Voided: "E refuzuar, paratë nuk u morën",
    Refunded: "E refuzuar, paratë u kthyen",
    Expired: "E skaduar",
    Superseded: "Zëvendësuar nga një pagesë më e re",
    Abandoned: "Anuluar nga klienti",
    Reversing: "Paratë po kthehen",
    ReversalFailed: "Paratë nuk u kthyen dot; financat u njoftuan"
  },
  "PaymentProcessorRefund.EntityName": PURCHASE_TYPES,
  "PaymentProcessorRefund.Status": PROCESSOR_REFUND_STATUS,
  "PaymentProcessorRefund.Origin": {
    Travel: "Gjirafa Travel",
    Dashboard: "Me dorë, jashtë Gjirafa Travel"
  },
  "PaymentProcessorRefund.FailureReason": {
    charge_for_pending_refund_disputed: "Pagesa u kontestua ndërkohë",
    declined: "Banka e refuzoi",
    expired_or_canceled_card: "Kartela ka skaduar ose është anuluar",
    insufficient_funds: "Nuk kishte mjete të mjaftueshme në llogarinë tonë",
    lost_or_stolen_card: "Kartela është humbur ose vjedhur",
    merchant_request: "U anulua me kërkesën tonë",
    unknown: "E panjohur"
  },
  "Refund.EntityName": PURCHASE_TYPES,
  "Refund.ProcessorStatus": PROCESSOR_REFUND_STATUS,
  "RefundLine.InvoiceLeg": { Outgoing: "Vajtja", Return: "Kthimi" },
  // QuickBooks product types, stored as their number.
  "RefundLine.ProductType": {
    1: "Bileta (neto)",
    2: "Komisioni",
    3: "Tarifa e shërbimit",
    6: "Paketa (neto)",
    7: "Tarifa FlexiRide",
    8: "Paketa eSIM",
    9: "Konciergjeri",
    10: "TextMeMyTrip",
    11: "Diferenca e çmimit",
    12: "Vlera e mbajtur",
    13: "Kthim i hapur i skaduar",
    14: "Ruajtja e bagazhit"
  },
  "PaymentDispute.EntityName": PURCHASE_TYPES,
  "PaymentDispute.Status": { Open: "I hapur", Closed: "I mbyllur" },
  "PaymentDispute.Outcome": { Won: "U fitua", Lost: "U humb", Withdrawn: "U tërhoq" },
  "PaymentDispute.ProcessorStatus": DISPUTE_PROCESSOR_STATUS,
  "PaymentDispute.Reason": {
    bank_cannot_process: "Banka nuk mund ta përpunojë",
    check_returned: "Çeku u kthye",
    credit_not_processed: "Klienti thotë se rimbursimi nuk i erdhi",
    customer_initiated: "Kërkesë e klientit",
    debit_not_authorized: "Tërheqje e paautorizuar",
    duplicate: "Pagesë e dyfishtë",
    fraudulent: "Pagesë mashtruese",
    general: "E përgjithshme",
    incorrect_account_details: "Të dhëna të gabuara të llogarisë",
    insufficient_funds: "Mjete të pamjaftueshme",
    noncompliant: "Nuk përputhet me rregullat e kartelave",
    product_not_received: "Klienti thotë se nuk e mori shërbimin",
    product_unacceptable: "Klienti nuk është i kënaqur me shërbimin",
    subscription_canceled: "Abonimi ishte anuluar",
    unrecognized: "Klienti nuk e njeh pagesën"
  }
};
